"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEntityChangeRequestFromData = exports.createModelFromData = exports.createEntityFromData = exports.createUsersFromDataArray = exports.convertPageDataEntities = exports.createUserFromData = exports.createValidationErrorsFromResponse = exports.createChangeRequestConnectionFromData = exports.createConnectionListFromEntityConnectionList = exports.createEntityConnectionFromData = exports.createConnectionFromData = exports.createChangeRequestConnectionListFromData = exports.createConnectionListFromData = exports.createEntityChangeRequestListFromData = exports.createModelListFromData = exports.createEntityListFromData = void 0;
var band_1 = require("../models/entities/band");
var album_1 = require("../models/entities/album");
var award_1 = require("../models/entities/award");
var audio_1 = require("../models/entities/audio");
var event_1 = require("../models/entities/event");
var event_series_1 = require("../models/entities/event-series");
var image_1 = require("../models/entities/image");
var institution_1 = require("../models/entities/institution");
var movie_1 = require("../models/movie");
var musical_period_1 = require("../models/entities/musical-period");
var person_1 = require("../models/entities/person");
var publication_1 = require("../models/entities/publication");
var publication_item_1 = require("../models/entities/publication-item");
var record_1 = require("../models/entities/record");
var song_1 = require("../models/entities/song");
var music_album_1 = require("../models/entities/music-album");
var tag_1 = require("../models/entities/tag");
var venue_1 = require("../models/entities/venue");
var video_1 = require("../models/entities/video");
var connection_1 = require("../models/connections/connection");
var person_connection_1 = require("../models/connections/person-connection");
var band_change_request_1 = require("../models/change-requests/band-change-request");
var album_change_request_1 = require("../models/change-requests/album-change-request");
var award_change_request_1 = require("../models/change-requests/award-change-request");
var event_change_request_1 = require("../models/change-requests/event-change-request");
var event_series_change_request_1 = require("../models/change-requests/event-series-change-request");
var institution_change_request_1 = require("../models/change-requests/institution-change-request");
var musical_period_change_request_1 = require("../models/change-requests/musical-period-change-request");
var person_change_request_1 = require("../models/change-requests/person-change-request");
var publication_change_request_1 = require("../models/change-requests/publication-change-request");
var publication_item_change_request_1 = require("../models/change-requests/publication-item-change-request");
var record_change_request_1 = require("../models/change-requests/record-change-request");
var song_change_request_1 = require("../models/change-requests/song-change-request");
var music_album_change_request_1 = require("../models/change-requests/music-album-change-request");
var tag_change_request_1 = require("../models/change-requests/tag-change-request");
var venue_change_request_1 = require("../models/change-requests/venue-change-request");
var video_change_request_1 = require("../models/change-requests/video-change-request");
var change_request_person_connection_1 = require("../models/change-request-connections/change-request-person-connection");
var change_request_connection_1 = require("../models/change-request-connections/change-request-connection");
var image_change_request_1 = require("../models/change-requests/image-change-request");
var audio_change_request_1 = require("../models/change-requests/audio-change-request");
var user_1 = require("../models/user");
var validation_error_1 = require("../models/validation-error");
var favorite_1 = require("../models/favorite");
var audio_playlist_1 = require("../models/audio-playlist");
var audio_track_1 = require("../models/audio-track");
var video_playlist_1 = require("../models/video-playlist");
var video_track_1 = require("../models/video-track");
var connection_history_1 = require("../models/connection-history");
var reference_change_request_1 = require("../models/change-requests/reference-change-request");
var reference_1 = require("../models/entities/reference");
var entity_connection_1 = require("../models/entity-connection");
var createEntityListFromData = function (items) {
    return items.map(function (item) { return exports.createEntityFromData(item); });
};
exports.createEntityListFromData = createEntityListFromData;
var createModelListFromData = function (items) {
    return items.map(function (item) { return exports.createModelFromData(item); });
};
exports.createModelListFromData = createModelListFromData;
var createEntityChangeRequestListFromData = function (items) {
    return items.map(function (item) { return exports.createEntityChangeRequestFromData(item); });
};
exports.createEntityChangeRequestListFromData = createEntityChangeRequestListFromData;
/**
 * @param items
 * @param connectionsOfEntityIri The IRI of the entity that the connection list was requested of
 */
var createConnectionListFromData = function (items, connectionsOfEntityIri) {
    return items.map(function (item) { return exports.createConnectionFromData(item, connectionsOfEntityIri); });
};
exports.createConnectionListFromData = createConnectionListFromData;
/**
 * @param items
 * @param connectionsOfEntityIri The IRI of the entity that the connection list was requested of
 */
var createChangeRequestConnectionListFromData = function (items, connectionsOfEntityIri) {
    return items.map(function (item) { return exports.createChangeRequestConnectionFromData(item, connectionsOfEntityIri); });
};
exports.createChangeRequestConnectionListFromData = createChangeRequestConnectionListFromData;
var createConnectionFromData = function (data, connectionOfEntityIri) {
    if (!data.hasOwnProperty('@type')) {
        return null;
    }
    switch (data['@type']) {
        case 'PersonConnection':
            return new person_connection_1.PersonConnection(data, connectionOfEntityIri);
    }
    return new connection_1.Connection(data, connectionOfEntityIri);
};
exports.createConnectionFromData = createConnectionFromData;
var createEntityConnectionFromData = function (items) {
    return items.map(function (item) { return new entity_connection_1.EntityConnection(item); });
};
exports.createEntityConnectionFromData = createEntityConnectionFromData;
var createConnectionListFromEntityConnectionList = function (items, fromEntity) {
    return exports.createEntityConnectionFromData(items).map(function (item) {
        var conn;
        switch (item.type) {
            case 'personal_connection':
                conn = new person_connection_1.PersonConnection(null, '');
                break;
            case 'connection':
            default:
                conn = new connection_1.Connection(null, '');
        }
        conn.id = item.id;
        conn['@id'] = item.id.toString();
        conn['@type'] = conn.type = item.type;
        conn.fromEntity = fromEntity;
        conn.toEntity = item.entity;
        conn.dateFrom = item.dateFrom;
        conn.dateTo = item.dateTo;
        var side = item.direction === 'ltr' ? 'left' : 'right';
        var oppositeSide = item.direction === 'ltr' ? 'right' : 'left';
        conn[side + "Description"] = item.description;
        conn[side + "SortOrder"] = item.sortOrder;
        conn[oppositeSide + "Description"] = item.oppositeDescription;
        conn[oppositeSide + "SortOrder"] = item.oppositeSortOrder;
        return conn;
    });
};
exports.createConnectionListFromEntityConnectionList = createConnectionListFromEntityConnectionList;
var createChangeRequestConnectionFromData = function (data, connectionOfEntityIri) {
    if (!data.hasOwnProperty('@type')) {
        return null;
    }
    switch (data['@type']) {
        case 'ChangeRequestPersonConnection':
            return new change_request_person_connection_1.ChangeRequestPersonConnection(data, connectionOfEntityIri);
    }
    return new change_request_connection_1.ChangeRequestConnection(data, connectionOfEntityIri);
};
exports.createChangeRequestConnectionFromData = createChangeRequestConnectionFromData;
var createValidationErrorsFromResponse = function (response) {
    if (!Array.isArray(response.violations) || !response.violations.length) {
        return [];
    }
    return response.violations.map(function (violation) {
        return new validation_error_1.ValidationError({
            propertyName: violation.propertyPath,
            message: violation.message,
        });
    });
};
exports.createValidationErrorsFromResponse = createValidationErrorsFromResponse;
var createUserFromData = function (data) {
    var user = new user_1.User(data);
    if (data.policyAcceptedAt) {
        user.policyAccepted = new Date(data.policyAcceptedAt);
    }
    if (data.policyUpdatedAt) {
        user.policyUpdated = new Date(data.policyUpdatedAt);
    }
    return user;
};
exports.createUserFromData = createUserFromData;
var convertPageDataEntities = function (alias, responseData) {
    if (alias === 'homepage' && responseData.data) {
        ;
        ['collections', 'carousels'].map(function (key) {
            Object.entries(responseData.data[key]).forEach(function (_a) {
                var itemId = _a[0], item = _a[1];
                if (!item.items || item.items.length === 0) {
                    return;
                }
                item.items.forEach(function (listItem) {
                    if (listItem.entity === undefined || listItem.entity.type === undefined) {
                        return;
                    }
                    listItem.entity['@id'] = listItem.entity.id;
                    listItem.entity['@type'] = listItem.entity.type;
                    listItem.entity = exports.createEntityFromData(listItem.entity);
                });
            });
        });
        if (responseData.data.randomVideoPlayer && responseData.data.randomVideoPlayer.item) {
            var video = responseData.data.randomVideoPlayer.item.entity;
            video['@id'] = video.id;
            video['@type'] = video.type;
            responseData.data.randomVideoPlayer.item.entity = exports.createEntityFromData(video);
        }
    }
    return responseData;
};
exports.convertPageDataEntities = convertPageDataEntities;
var createUsersFromDataArray = function (dataArray) {
    return dataArray.map(function (data) {
        return exports.createUserFromData(data);
    });
};
exports.createUsersFromDataArray = createUsersFromDataArray;
var createEntityFromData = function (data) {
    if (!data.hasOwnProperty('@type')) {
        return null;
    }
    switch (data['@type']) {
        case 'Band':
            return new band_1.Band(data);
        case 'Album':
            return new album_1.Album(data);
        case 'Audio':
            return new audio_1.Audio(data);
        case 'Award':
            return new award_1.Award(data);
        case 'Event':
            return new event_1.Event(data);
        case 'EventSeries':
            return new event_series_1.EventSeries(data);
        case 'Image':
            return new image_1.Image(data);
        case 'Institution':
            return new institution_1.Institution(data);
        case 'Movie':
            return new movie_1.Movie(data);
        case 'MusicalPeriod':
            return new musical_period_1.MusicalPeriod(data);
        case 'Person':
            return new person_1.Person(data);
        case 'Publication':
            return new publication_1.Publication(data);
        case 'PublicationItem':
            return new publication_item_1.PublicationItem(data);
        case 'Record':
            return new record_1.Record(data);
        case 'Reference':
            return new reference_1.Reference(data);
        case 'Song':
            return new song_1.Song(data);
        case 'MusicAlbum':
            return new music_album_1.MusicAlbum(data);
        case 'Tag':
            return new tag_1.Tag(data);
        case 'Venue':
            return new venue_1.Venue(data);
        case 'Video':
            return new video_1.Video(data);
    }
    return null;
};
exports.createEntityFromData = createEntityFromData;
var createModelFromData = function (data) {
    if (!data.hasOwnProperty('@type')) {
        return null;
    }
    switch (data['@type']) {
        case 'ConnectionHistory':
            return new connection_history_1.ConnectionHistory(data);
        case 'Favorite':
            return new favorite_1.Favorite(data);
        case 'AudioPlaylist':
            return new audio_playlist_1.AudioPlaylist(data);
        case 'VideoPlaylist':
            return new video_playlist_1.VideoPlaylist(data);
        case 'AudioTrack':
            return new audio_track_1.AudioTrack(data);
        case 'VideoTrack':
            return new video_track_1.VideoTrack(data);
        case 'User':
            return new user_1.User(data);
    }
    return null;
};
exports.createModelFromData = createModelFromData;
var createEntityChangeRequestFromData = function (data) {
    if (!data.hasOwnProperty('@type')) {
        return null;
    }
    switch (data['@type']) {
        case 'AlbumChangeRequest':
            return new album_change_request_1.AlbumChangeRequest(data);
        case 'AudioChangeRequest':
            return new audio_change_request_1.AudioChangeRequest(data);
        case 'AwardChangeRequest':
            return new award_change_request_1.AwardChangeRequest(data);
        case 'BandChangeRequest':
            return new band_change_request_1.BandChangeRequest(data);
        case 'EventChangeRequest':
            return new event_change_request_1.EventChangeRequest(data);
        case 'EventSeriesChangeRequest':
            return new event_series_change_request_1.EventSeriesChangeRequest(data);
        case 'ImageChangeRequest':
            return new image_change_request_1.ImageChangeRequest(data);
        case 'InstitutionChangeRequest':
            return new institution_change_request_1.InstitutionChangeRequest(data);
        case 'MusicalPeriodChangeRequest':
            return new musical_period_change_request_1.MusicalPeriodChangeRequest(data);
        case 'PersonChangeRequest':
            return new person_change_request_1.PersonChangeRequest(data);
        case 'PublicationChangeRequest':
            return new publication_change_request_1.PublicationChangeRequest(data);
        case 'PublicationItemChangeRequest':
            return new publication_item_change_request_1.PublicationItemChangeRequest(data);
        case 'RecordChangeRequest':
            return new record_change_request_1.RecordChangeRequest(data);
        case 'ReferenceChangeRequest':
            return new reference_change_request_1.ReferenceChangeRequest(data);
        case 'SongChangeRequest':
            return new song_change_request_1.SongChangeRequest(data);
        case 'TagChangeRequest':
            return new tag_change_request_1.TagChangeRequest(data);
        case 'MusicAlbumChangeRequest':
            return new music_album_change_request_1.MusicAlbumChangeRequest(data);
        case 'VenueChangeRequest':
            return new venue_change_request_1.VenueChangeRequest(data);
        case 'VideoChangeRequest':
            return new video_change_request_1.VideoChangeRequest(data);
    }
    return null;
};
exports.createEntityChangeRequestFromData = createEntityChangeRequestFromData;
